import * as React from "react";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Checkbox, Typography } from "@mui/material";
import { useEffect, forwardRef, useImperativeHandle } from "react";
import {
  setAccess,
  setIndustry,
  setOrganisation,
  setOrganisations,
  setCategory,
  setPackage,
  setReports,
  setType,
} from "../../reduxSlices/headerSlice";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { ReactComponent as FilterIcon } from "../../assets/images/Filter.svg";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: "auto",
      minWidth: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const CommonDropdown = forwardRef(({ options, name }, ref) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const [personName, setPersonName] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(typeof value === "string" ? value.split(",") : value);
    setSelectedOption(typeof value === "string" ? value.split(",") : value);
  };

  useEffect(() => {
    if (name === "Type") dispatch(setType(selectedOption));
    if (name === "Industry") dispatch(setIndustry(selectedOption));
    if (name === "Package") dispatch(setPackage(selectedOption));
    if (name === "Organisation") dispatch(setOrganisation(selectedOption));
    if (name === "Access") dispatch(setAccess(selectedOption));
    if (name === "Reports") dispatch(setReports(selectedOption));
    if (name === "Organisations") dispatch(setOrganisations(selectedOption));
    if (name === "Category") dispatch(setCategory(selectedOption));
  }, [selectedOption]);

  useImperativeHandle(ref, () => ({
    clearSelectedItems() {
      setSelectedOption([]);
      setPersonName([]);
    },
  }));
  useEffect(() => {
    console.log("personName", personName);
    console.log("selectedOption", selectedOption);
    console.log("options", options);
  }, [personName, selectedOption, options]);

  return (
    <div>
      <FormControl sx={{ width: "auto" }}>
        <Select
          sx={{ height: "44px" }}
          multiple
          displayEmpty
          value={personName}
          onChange={handleChange}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            // if (selected.length === 0) {
            //   return <Typography>{name}</Typography>;
            // }
            return (
              <div style={{ display: "flex", alignItems: "center" }}>
                <FilterIcon />
                <Typography
                  sx={{
                    marginLeft: "10px",
                    fontSize: "14px",
                    fontFamily: "Montserrat",
                    color: "#5a5a5a",
                    fontWeight: 600,
                  }}
                >
                  {name}{" "}
                  {personName?.length ? (
                    <span
                      style={{
                        borderRadius: "50%",
                        backgroundColor: "#f7954c",
                        color: "#fff",
                        fontSize: "10px",
                        padding: "3px 7px 3px 7px",
                      }}
                    >
                      {personName?.length}
                    </span>
                  ) : (
                    ""
                  )}
                </Typography>
              </div>
            );
            // return selected.join(", ");
          }}
          MenuProps={MenuProps}
          inputProps={{ "aria-label": "Without label" }}
          SelectProps={{ IconComponent: () => null }}
        >
          {options?.map((name) => (
            <MenuItem
              key={name}
              value={name}
              style={getStyles(name, personName, theme)}
              sx={{
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <Checkbox
                color="warning"
                checked={personName.indexOf(name) > -1}
              />
              <Typography
                sx={{
                  fontSize: "14px",
                  fontFamily: "Montserrat",
                  color: "#5a5a5a",
                  fontWeight: 500,
                }}
              >
                {name}
              </Typography>
            </MenuItem>
          ))}
          {/* <MenuItem
            style={{
              position: "sticky",
              bottom: "0px",
              background: "#fff",
              height: "50px",
            }}
          >
            <Typography
              sx={{
                fontSize: "12px",
                fontFamily: "Montserrat",
                fontWeight: 600,
                color: "#a50218",
              }}
              onClick={handleReset}
            >
              Reset Filter
            </Typography>
          </MenuItem> */}
        </Select>
      </FormControl>
    </div>
  );
});
export default CommonDropdown;
